import React, {Component} from 'react';
import {Button, Input, Label} from "reactstrap";

class IbanField extends Component {

	constructor(props) {
		super(props);
		this.state = {
			rows: [],
		};

		this.removeRow = this.removeRow.bind(this);
		this.addRow = this.addRow.bind(this);
		this.onChangeField = this.onChangeField.bind(this);
	}

	componentDidMount() {
		this.setState({rows: this.props.rows})
	}

	onChangeField(e, i) {
		if (!e) return;

		let target = e.target;
		let {rows} = this.state;
		rows[i][target.name] = target.value;
		this.props.setIban(rows)
	}

	removeRow(rowIndex) {
		let {rows} = this.state;
		rows.splice(rowIndex, 1);
		this.props.setIban(rows)
	}

	addRow() {
		let {rows} = this.state;
		rows.push({branch: "", iban: ""});

		this.props.setIban(rows);
	}

	render() {
		return (
			<div style={{display: 'block', padding: '20px 5px 20px 10px', border: 'solid 1px #cacaca', borderRadius: '5px', width: '100%', margin: '5px 0'}}>
				<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
					<div style={{padding: '5px'}}>
						<h6 style={{margin: 0}}>
							IBAN
						</h6>
					</div>

					<div>
						<Button className="TekBtn ekle" onClick={this.addRow}>Ekle</Button>
					</div>
				</div>

				<div>
					{!this.state.rows || this.state.rows.length === 0 &&
					<div style={{display: 'flex', flexDirection: 'row'}}>
						<h2>
							IBAN eklenmedi.
						</h2>
					</div>}

					{this.state.rows && this.state.rows.length !== 0 && this.state.rows.map((row, i) =>
						<div key={i} style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
							<div style={{width: '24%'}}>
								<Label style={{margin: 0, fontWeight: 'bold'}}>Şube Adı/IBAN</Label>
							</div>

							<div style={{width: '34%'}}>
								<Input type="text" name="branch" value={row.branch}
									   onChange={e => this.onChangeField(e, i)}/>
							</div>

							<div style={{width: '34%'}}>
								<Input type="text" name="iban" value={row.iban}
									   onChange={e => this.onChangeField(e, i)}/>
							</div>

							<div style={{width: '8%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
								<button style={{marginBottom: '1px', padding: 0}} className="Btn"
										onClick={() => this.removeRow(i)}>
									<i className="fa fa-remove"/>
								</button>
							</div>
						</div>)
					}
				</div>
			</div>
		)
	}

}


export default IbanField;